import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
`;

export const WrapCaption = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 0px;

  h1 {
    text-align: center;
  }

  img {
    margin: 10px;
  }

  /* regular phones and below */
  @media (max-width: 424px) {
    h1 {
      font-size: 24px;
    }
  }
`;

export const WrapS = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  flex-wrap: wrap;

`;

export const Social = styled.div`
  display: flex;
  padding-top: 20px;

  a {
    text-decoration: none;
    padding: 12px;

    svg:hover {
      fill: #b566ff;
    }
  }
`;

export const Button = styled.button`
  background-color: #9c33ff;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  border: 0;
  border-radius: 4px;
  margin: 20px 10px;
  padding: 10px;
  justify-content: stretch;
  transition: .2s ease-in-out;

  &:hover {
    background-color: #b566ff;
  }
`;